import { Component, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from 'src/app/_services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})

export class SideNavComponent implements OnInit {

  @ViewChild('vendorsPanel') vendorsPanel: MatExpansionPanel;
  @ViewChild('vendorsPanel1') vendorsPanel1: MatExpansionPanel;

  constructor(
    public authService: AuthService
  ) { }

  imageServerPath: string = "../../../assets/images/final automated.png";
  ngOnInit(): void {
    var logo = this.authService.getRegistredUserDetails();
    if (logo) {
      this.imageServerPath = logo['logoFile'];
    }
  }

  onImgError(event) {
    var reset = event.target.src = "../../../assets/images/final automated.png";
  }

  events: string[] = [];
  opened: boolean;
  panelOpenState: boolean = false;

  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);

  public createImgPath = (serverPath: string) => {
    if (serverPath == null || serverPath == '' || serverPath == undefined) {
      return "../../../assets/images/final automated.png";
    }
    return environment.BaseApiUrl + `/Customer/image?fileName=${serverPath}`;
  }

  closeVendorsPanel() {
    this.vendorsPanel.close();
    this.vendorsPanel1.close();
}

}


